<header class="header-area">
    <div class="top-header">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-12">
                    <ul class="header-contact-info">
                        <li>{{ "Oyoun Charity Association" | translate }}</li>
                        <li>
                            {{ "Call US" | translate }}:
                            <a href="tel:+01321654214">+966577777777</a>
                        </li>
                        <li>
                            <div
                                class="dropdown language-switcher d-inline-block"
                            >
                                <button
                                    class="dropdown-toggle"
                                    type="button"
                                    (click)="toggleClass()"
                                >
                                    <img
                                        [src]="
                                            currentLang == 'en'
                                                ? 'assets/img/us-flag.jpg'
                                                : 'assets/img/saudi-flag.png'
                                        "
                                        alt="image"
                                    />
                                    <span
                                        >{{
                                            currentLang == "en"
                                                ? "Eng"
                                                : "Saudi"
                                        }}
                                        <i class="bx bx-chevron-down"></i
                                    ></span>
                                </button>
                                <div
                                    class="dropdown-menu"
                                    [class.active]="classApplied"
                                >
                                    <a
                                        class="dropdown-item d-flex align-items-center"
                                        (click)="changeLanguage('ar')"
                                    >
                                        <img
                                            src="assets/img/saudi-flag.png"
                                            class="shadow-sm"
                                            alt="flag"
                                        />
                                        <span>Saudi</span>
                                    </a>
                                    <a
                                        class="dropdown-item d-flex align-items-center"
                                        (click)="changeLanguage('en')"
                                    >
                                        <img
                                            src="assets/img/us-flag.jpg"
                                            class="shadow-sm"
                                            alt="flag"
                                        />
                                        <span>Eng</span>
                                    </a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="top-header-discount-info">
                        <p>{{ "Man gateway to his humanity" | translate }}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <ul class="header-top-menu">
                        <!-- <li><a routerLink="/login"><i class='bx bxs-user'></i> My Account</a></li> -->
                        <li>
                            <a href="/request-booking"
                                ><i class="bx bx-plus-circle"></i
                                >{{ "Request Booking" | translate }}</a
                            >
                        </li>
                        <li *ngIf="!isAuthenticated">
                            <a routerLink="/register"
                                ><i class="bx bx-log-in-circle"></i>
                                {{ "Register" | translate }}</a
                            >
                        </li>
                        <li *ngIf="!isAuthenticated">
                            <a routerLink="/login"
                                ><i class="bx bx-log-in"></i>
                                {{ "Login" | translate }}</a
                            >
                        </li>
                        <li *ngIf="isAuthenticated" (click)="logout()">
                            <a routerLink="/login"
                                ><i class="bx bx-log-in"></i>
                                {{ "Logout" | translate }}</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="navbar-area">
        <div class="louise-responsive-nav">
            <div class="container">
                <div class="louise-responsive-menu">
                    <div class="logo">
                        <a routerLink="/">
                            <img src="assets/img/logo.png" alt="logo" />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="louise-nav">
            <div class="container-fluid">
                <nav class="navbar navbar-expand-md navbar-light">
                    <a class="navbar-brand" routerLink="/">
                        <img src="assets/img/logo.png" alt="logo" />
                    </a>

                    <div class="collapse navbar-collapse mean-menu">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <a
                                    routerLink="/"
                                    class="nav-link"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    >{{ "Home" | translate }}</a
                                >
                                <!-- <ul class="dropdown-menu">
                                    <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Home 1</a></li>
    
                                    <li class="nav-item"><a routerLink="/home-two" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Home 2</a></li>
    
                                    <li class="nav-item"><a routerLink="/home-three" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Home 3</a></li>
    
                                    <li class="nav-item"><a routerLink="/home-four" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Home 4</a></li>
                                </ul> -->
                            </li>

                            <li class="nav-item">
                                <a
                                    href="javascript:void(0)"
                                    routerLink="/about"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    class="nav-link"
                                    >{{ "About US" | translate }}</a
                                >
                                <!-- <ul class="dropdown-menu">
                                    <li class="nav-item"><a routerLink="/listing-one" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Listing Layout 1</a></li>
    
                                    <li class="nav-item"><a routerLink="/listing-two" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Listing Layout 2</a></li>
    
                                    <li class="nav-item"><a routerLink="/listing-three" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Listing Layout 3</a></li>
    
                                    <li class="nav-item"><a routerLink="/listing-four" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Listing Layout 4</a></li>
    
                                    <li class="nav-item"><a routerLink="/listing-five" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Listing Layout 5</a></li>
    
                                    <li class="nav-item"><a routerLink="/listing-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Listing Details</a></li>
    
                                    <li class="nav-item"><a href="javascript:void(0)" class="nav-link">User Panel <i class='bx bx-chevron-right'></i></a>
                                        <ul class="dropdown-menu">
                                            <li class="nav-item"><a href="/admin-dashboard" class="nav-link">Dashboard</a></li>
            
                                            <li class="nav-item"><a href="/admin-dashboard/app-message" class="nav-link">Messages</a></li>
            
                                            <li class="nav-item"><a href="/admin-dashboard/bookings" class="nav-link">Bookings</a></li>
            
                                            <li class="nav-item"><a href="/admin-dashboard/reviews" class="nav-link">Reviews</a></li>
            
                                            <li class="nav-item"><a href="/admin-dashboard/bookmarks" class="nav-link">Bookmarks</a></li>
            
                                            <li class="nav-item"><a href="/admin-dashboard/my-listing" class="nav-link">My Listing</a></li>
            
                                            <li class="nav-item"><a href="/admin-dashboard/add-listing" class="nav-link">Add Listing</a></li>
    
                                            <li class="nav-item"><a href="/admin-dashboard/my-profile" class="nav-link">Profile</a></li>
                                        </ul>
                                    </li>
                                </ul> -->
                            </li>

                            <!-- <li class="nav-item megamenu">
                                <a
                                    href="javascript:void(0)"
                                    routerLink="/faqs"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    class="nav-link"
                                    >{{ "Faq" | translate }}</a
                                >
                                    
                            </li> -->

                            <!-- <li class="nav-item"><a href="javascript:void(0)" class="nav-link">Shop <i class='bx bx-chevron-down'></i></a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item"><a routerLink="/product-list" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Product List</a></li>
    
                                    <li class="nav-item"><a routerLink="/cart" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Cart</a></li>
    
                                    <li class="nav-item"><a routerLink="/checkout" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Checkout</a></li>
    
                                    <li class="nav-item"><a routerLink="/products-details" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Product Details</a></li>
                                </ul>
                            </li>
    
                            <li class="nav-item"><a href="javascript:void(0)" class="nav-link">Blog <i class='bx bx-chevron-down'></i></a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item"><a routerLink="/blog-one" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Grid (2 in Row)</a></li>
    
                                    <li class="nav-item"><a routerLink="/blog-two" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Grid (3 in Row)</a></li>
    
                                    <li class="nav-item"><a routerLink="/blog-three" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Grid (Full Width)</a></li>
    
                                    <li class="nav-item"><a routerLink="/blog-four" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Right Sidebar</a></li>
    
                                    <li class="nav-item"><a routerLink="/blog-five" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Masonry (3 in Row)</a></li>
    
                                    <li class="nav-item"><a href="javascript:void(0)" class="nav-link">Single Post <i class='bx bx-chevron-right'></i></a>
                                        <ul class="dropdown-menu">
                                            <li class="nav-item"><a routerLink="/blog-details-one" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Default</a></li>
    
                                            <li class="nav-item"><a routerLink="/blog-details-two" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">With Video</a></li>
    
                                            <li class="nav-item"><a routerLink="/blog-details-three" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">With Image Slider</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li> -->

                            <li class="nav-item">
                                <a
                                    routerLink="/contact"
                                    class="nav-link"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    >{{ "Contact US" | translate }}</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    routerLink="/patient-account"
                                    class="nav-link"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    >{{ "My Account" | translate }}</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    routerLink="/edit-profile"
                                    class="nav-link"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    >{{ "My Profile" | translate }}</a
                                >
                            </li>
                        </ul>

                        <div class="others-option">
                            <div class="d-flex align-items-center">
                                <!-- <div class="option-item">
                                    <div class="search-btn-box">
                                        <i class="search-btn bx bx-search-alt"></i>
                                    </div>
                                </div>
    
                                <div class="option-item">
                                    <div class="cart-btn">
                                        <a href="#" data-toggle="modal" data-target="#shoppingCartModal"><i class='bx bx-shopping-bag'></i><span>0</span></a>
                                    </div>
                                </div> -->

                                <div class="option-item">
                                    <a
                                        href="/request-booking"
                                        class="default-btn"
                                        ><i class="bx bx-plus"></i>
                                        {{ "Request Booking" | translate }}</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</header>
